export function lightenColor(color: string | undefined, percent: number): string {
    // Parse the color from the hex code
    if (color === undefined) return '#000'
    let r = parseInt(color.substring(1, 3), 16);
    let g = parseInt(color.substring(3, 5), 16);
    let b = parseInt(color.substring(5, 7), 16);

    // Increase each component by the specified percentage
    r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
    g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
    b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));



    // Convert back to hex
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function toHex(num: number): string {
    const hex = num.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}